import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

export const HolderNormalizeDialog = ({ open, onOpenChange, onDone }) => {
  const [busy, setBusy] = useState(false);
  const [info, setInfo] = useState(null);

  const run = async (apply) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/reports/document-holders/normalize?apply=${apply ? 1 : 0}`);
      setInfo(data);
      if (apply) {
        toast.success(`${data.updated} kaydın belge yeri standart hâle getirildi`);
        onDone?.();
      }
    } catch (e) {
      toast.error(e.response?.data?.detail || "İşlem başarısız");
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) setInfo(null); onOpenChange(o); }}>
      <DialogContent className="max-w-2xl" data-testid="holder-normalize-dialog">
        <DialogHeader>
          <DialogTitle>Belge Yeri Yazım Düzeltme</DialogTitle>
          <DialogDescription>
            Elle girilmiş yazımları standart hâle getirir: "Şube — Aliağa" / "İzmir şube" /
            "Ereğli şb …" → "<b>X Şube</b>", "Kendisi" / "Firma kendi çıkarttı" → "<b>Kendi Aldı</b>".
            Kişi adı yazılmış kayıtlara ve belirsiz olanlara dokunulmaz.
          </DialogDescription>
        </DialogHeader>

        {info && (
          <div className="space-y-2 text-sm" data-testid="holder-normalize-summary">
            <p>{info.total} kayıt tarandı · düzeltilecek: <b className="text-emerald-600">{info.will_change}</b> · elle bakılmalı: {info.manual?.length || 0}</p>
            {info.changes?.length > 0 && (
              <div className="max-h-48 overflow-auto text-xs text-muted-foreground space-y-0.5 border border-border rounded-md p-2">
                {info.changes.map((c) => (
                  <div key={c.id}>#{c.committee_no} {c.company_name}: <span className="line-through">{c.old}</span> → <b className="text-foreground">{c.new}</b></div>
                ))}
              </div>
            )}
            {info.manual?.length > 0 && (
              <div className="max-h-32 overflow-auto text-xs text-amber-600 space-y-0.5 border border-amber-400/50 rounded-md p-2" data-testid="holder-normalize-manual">
                <p className="font-medium">Elle düzeltmeniz gerekenler:</p>
                {info.manual.map((c) => <div key={c.id}>#{c.committee_no} {c.company_name}: “{c.old}”</div>)}
              </div>
            )}
            {info.updated > 0 && <p className="text-emerald-600 font-medium">{info.updated} kayıt güncellendi.</p>}
          </div>
        )}

        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="holder-normalize-cancel">Kapat</Button>
          <Button variant="secondary" disabled={busy} onClick={() => run(false)} data-testid="holder-normalize-check">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Kontrol Et"}
          </Button>
          <Button className="bg-[#0F2C59] hover:bg-[#0F2C59]/90" disabled={busy || !info || !info.will_change}
            onClick={() => run(true)} data-testid="holder-normalize-apply">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : `Uygula (${info?.will_change ?? 0})`}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default HolderNormalizeDialog;
